// Extrai o texto legível do conteúdo de uma mensagem do Mastra.
// O `content` normalmente vem como uma string JSON no formato:
// { "parts": [{ "type": "text", "text": "..." }], "content": "..." }
export const extractMessageText = (content) => {
  if (content == null) return "";

  let parsed = content;

  if (typeof content === "string") {
    try {
      parsed = JSON.parse(content);
    } catch (e) {
      // Não é JSON, retorna a própria string.
      return content;
    }
  }

  if (parsed && Array.isArray(parsed.parts)) {
    return parsed.parts
      .filter((part) => part.type === "text")
      .map((part) => part.text)
      .join("\n");
  }

  if (typeof parsed === "string") return parsed;

  return JSON.stringify(parsed);
};
